import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ApisService } from '@core/services/apis.service';
import { LoadingService } from '@core/services/loading.service';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-user-articles',
  templateUrl: './user-articles.component.html',
  styleUrls: ['./user-articles.component.scss']
})
export class UserArticlesComponent implements OnInit {

      public currentPage = 1; 
   public categories : any
  public totalItems = 0;
public articleDetails: any[] = [];

  constructor( private apisService: ApisService,
          private route: ActivatedRoute,
         private loading : LoadingService,
        private toastr : ToastrService,
        private translate: TranslateService
      ) { }

    ngOnInit(): void {
 const articleId = this.route.snapshot.paramMap.get('id');
  if (articleId) {
    this.getUserArticles(articleId);
  }
      // this.postCountires();
  }

 

getUserArticles(id: any) {
  this.apisService.getUserArticles(id).subscribe({
    next: (res) => {
      this.articleDetails = res.data;
      console.log(this.articleDetails);
      this.loading.hide();
    },
    error: (err) => {
      console.log('error in fetching article details', err);
  this.translate.get(['MENU.DASHBOARD.ERROR', 'MENU.DASHBOARD.UNEXPECTED_ERROR']).subscribe(translations => {
    this.toastr.error(translations['MENU.DASHBOARD.UNEXPECTED_ERROR'], translations['MENU.DASHBOARD.ERROR']);
  });      this.loading.hide();
    }
  });
}

     /*----------  Handling image Error  ----------*/
  handleImageError(event) {
    event.target.src = 'assets/images/icons/logo.jpg';
  }
 
}
